import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Store } from '@ngrx/store';
import { EmployeesAPI } from 'src/app/apis/employees.service';
import { Family_member } from 'src/app/models/family_member.model';
import {
  addFamilyMember,
  addFamilyMemberSuccess,
  deleteFamilyMember,
  updateFamilyMember,
  updateFamilyMemberSuccess,
} from './../actions/family-members.action';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { map, switchMap, filter, shareReplay, take, catchError } from 'rxjs/operators';
import { Family_membersAPI } from 'src/app/apis/family_members.service';
import { calculateAge } from '../../pipes-utils/date_formatter';
import {
  deleteFamilyMemberSuccess,
  loadFamilyMember,
  loadFamilyMemberSuccess,
} from '../actions/family-members.action';
import { nextOfflineIndex } from '../reducers/offline.reducer';
import { UpdateSync } from '../actions/offline.action';
import { of } from 'rxjs';

@Injectable()
export class FamilyMemberEffect {
  adapter: EntityAdapter<Family_member> = createEntityAdapter<Family_member>();
  
  loadFamilyMembers$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadFamilyMember),
      switchMap(() =>
        this.familyMemberAPI.getFamilyMembers().pipe(
          map((payload) => {
            const processedMembers = payload.map((element) => ({
              ...element,
              age: element.birth_date ? calculateAge(new Date(element.birth_date)) : 0,
            }));
            return loadFamilyMemberSuccess({ familyMembers: processedMembers });
          }),
          catchError((error) => of({ type: '[Family Members] Load Family Members Error', error }))
        )
      )
    )
  );

  deleteFamilyMember$ = createEffect(() =>
    this.actions.pipe(
      ofType(deleteFamilyMember),
      switchMap((action) => 
        this.familyMemberAPI.deleteFamilyMember(action.id).pipe(
          map((value) => deleteFamilyMemberSuccess({ id: value?.id })),
          catchError((error) => of({ type: '[Family Members] Delete Family Member Error', error }))
        )
      )
    )
  );

  updateFamilyMember$ = createEffect(() =>
    this.actions.pipe(
      ofType(updateFamilyMember),
      switchMap((action) => {
        return this.familyMemberAPI.updateFamilyMembers(action.data).pipe(
          map((result) => {
            return { result };
          })
        );
      }),

      map(({ result }) => {
        // return updateFamilyMemberSuccess({ data: result });
        return UpdateSync({
          data: result,
          offlineId: result.id,
          stateName: 'familyMembers',
        });
      })
    )
  );

  addFamilyMember$ = createEffect(() =>
    this.actions.pipe(
      ofType(addFamilyMember),
      switchMap((action) =>
        this.familyMemberAPI.storeFamilyMembers(action.data).pipe(
          map((result: Family_member) => {
            return { result, props: action };
          })
        )
      ),
      switchMap(async ({ result, props }) => {
        return addFamilyMemberSuccess({
          data: result,
          offlineId: await this.store
            .select(nextOfflineIndex)
            .pipe(take(1))
            .toPromise(),
        });
      })
    )
  );
  addFamilyMemberSuccess$ = createEffect(() =>
    this.actions.pipe(
      ofType(addFamilyMemberSuccess),
      map((action: any) => {
        //  if (action?.props?.should_add_employee) {
        //   let member = action.data;
        //   member.farm_id = action?.props.farm_id;
        //   member.morphable_type = 'FamilyMember';
        //   member.morphable_id = member.id;
        //   return this.employeeAPI.saveEmployee(member);
        // }
        return UpdateSync({
          data: action.data,
          offlineId: action.offlineId,
          stateName: 'familyMembers',
        });
      })
    )
  );
  private state$: any;

  constructor(
    private familyMemberAPI: Family_membersAPI,
    private actions: Actions,
    public translateService: TranslateService,
    private employeeAPI: EmployeesAPI,
    private store: Store<{ connection: any; familyMembers: any }>
  ) {
    this.state$ = this.store.select('familyMembers').pipe(
      filter(Boolean), // Ignore the initial null state
      shareReplay(1) // Share the state across multiple subscribers
    );
  }
}
